"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var getSliderPosition = function getSliderPosition(i, count) {
  if (i === void 0) {
    i = 0;
  }

  if (count === void 0) {
    count = 1;
  }

  return 100 / count * i;
};

var patternStyles = {
  aside: styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    top: -0.25rem;\n  "], ["\n    top: -0.25rem;\n  "]))),
  main: styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    bottom: -0.25rem;\n  "], ["\n    bottom: -0.25rem;\n  "]))),
  schedule: styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n    border-bottom: none;\n  "], ["\n    border-bottom: none;\n  "]))),
  nested: styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n    background: ", ";\n    border-radius: 1.625rem;\n    z-index: -1;\n    height: 100%;\n    border-bottom: none;\n  "], ["\n    background: ", ";\n    border-radius: 1.625rem;\n    z-index: -1;\n    height: 100%;\n    border-bottom: none;\n  "])), function (_a) {
    var theme = _a.theme;
    return ui_helper_deep_branding_1.getFromTheme('COLOR.BLUE.100', theme);
  })
};
exports.Slider = styled_components_1.default.div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  width: ", "%;\n  height: 0;\n  border-bottom: ", ";\n  left: ", "%;\n  transition: left 0.25s cubic-bezier(0.66, 0.22, 0.44, 0.82);\n  z-index: 1;\n\n  ", "\n"], ["\n  position: absolute;\n  width: ", "%;\n  height: 0;\n  border-bottom: ", ";\n  left: ", "%;\n  transition: left 0.25s cubic-bezier(0.66, 0.22, 0.44, 0.82);\n  z-index: 1;\n\n  ", "\n"])), function (_a) {
  var count = _a.count;
  return 100 / count;
}, function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('LINE.ACCENT_BORDER', theme);
}, function (_a) {
  var count = _a.count,
      selectedIndex = _a.selectedIndex;
  return getSliderPosition(selectedIndex, count);
}, function (props) {
  return ui_helper_props_to_styles_1.mapStyles(props, 'pattern', patternStyles);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;